// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n@media only screen and (max-width: 767px) {\n.fa-times[data-v-36508848] {\n\t\tcolor: #333 !important;\n}\n}\n.modal-dialog[data-v-36508848] {\n\tcolor: black;\n}\n", ""]);
// Exports
module.exports = exports;
